import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import {
  ButtonOutlined,
  ButtonContained,
} from '../components/app-button/button'
import cx from 'classnames'
import AppBarInner from '../components/app-bar/AppBarInner'
import Wrapper from '../components/wrapper'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import CustomizeAll from '../components/сustomize-all/'

import {
  YandexMarketIcon,
  YandexDirectIcon,
  GoogleAdsIcon,
  VkIcon,
  FbIcon,
  AccountIdentifierIcon,
  AccountWaitIcon,
  AccountAlertIcon,
  AddItemIcon,
  CriteoIcon,
  DinRemIcon,
  MyTargetIcon,
  ArrowAside,
} from '../components/app-icon/Icons'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px',
    transition: 'background-color .2s linear',
    '&:hover': {
      backgroundColor: 'rgb(255, 204, 0, 0.2)',
    },
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },
  listChanel: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: 6,
    marginTop: 30,
    padding: 0,
    listStyleType: 'none',
    flexWrap: 'wrap',
  },
  ChanelItem: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    marginRight: 30,
    marginBottom: 30,
    borderRadius: '100%',
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
  },
  ChanelIcon: {
    width: 35,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ChanelStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    position: 'absolute',
    bottom: 0,
    right: -7,
    width: 24,
    height: 24,
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
    cursor: 'pointer',
  },
  ChanelAddIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  ChanelRemoveIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  content: {
    padding: '0 40px 30px 22px',
  },
  active: {
    border: 'solid 1px #8866ff',
    boxShadow: '0 0 8px 0 #8866ff80',
    '& span': {
      border: 'solid 1px #8866ff',
      boxShadow: '0 0 8px 0 #8866ff80',
    },
  },
  finishBtn: {
    display: 'block',
    textDecoration: 'none',
    marginTop: 25,
    position: 'relative',
    left: 0,
    width: 160,
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: '100%',
      left: 14,
      height: 25,
      width: 1,
      backgroundColor: 'rgba(136, 102, 255, 0.2)',
    },
  },
  finishContent: {
    position: 'relative',
    marginTop: 20,
    fontFamily: 'Caveat, cursive',
    letterSpacing: 1.1,
    color: 'rgba(0, 0, 0, 0.6)',
  },
  arrowAside: {
    position: 'absolute',
    left: -75,
    marginTop: 25,
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class GoogleAdsSourceConfirm extends Component {
  state = {
    activeStep: 3,
    dataSources: window.state.dataSources,
    inactiveDataSources: window.state.inactiveDataSources,
    hasStatistics: window.state.hasStatistics,
    errorMessage: window.state.errorMessage,
    isCard: window.state.cardTest,
  }

  render() {
    const { classes } = this.props
    const {
      dataSources,
      inactiveDataSources,
      hasStatistics,
      errorMessage,
      isCard,
    } = this.state

    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    const icon = type => {
      switch (type) {
        case 'yandex_market':
          return <YandexMarketIcon className={classes.ChanelIcon} />
        case 'yandex_direct':
          return <YandexDirectIcon className={classes.ChanelIcon} />
        case 'google_ads':
          return <GoogleAdsIcon className={classes.ChanelIcon} />
        case 'vkontakte':
          return <VkIcon className={classes.ChanelIcon} />
        case 'criteo':
          return <CriteoIcon className={classes.ChanelIcon} />
        case 'dinrem':
          return <DinRemIcon className={classes.ChanelIcon} />
        case 'facebook':
          return <FbIcon className={classes.ChanelIcon} />
        case 'mytarget':
          return <MyTargetIcon className={classes.ChanelIcon} />
        default:
          break
      }
    }

    const action = status => {
      switch (status) {
        case 'inactive':
          return <AddItemIcon className={classes.ChanelAddIcon} />
        case 'active':
          return <OkIcon className={classes.ChanelRemoveIcon} />
        default:
          break
      }
    }

    const statusSymbol = type => {
      switch (type) {
        case 'wait':
          return <AccountWaitIcon className={classes.chanelStatusIcon} />
        case 'ok':
          return <AccountIdentifierIcon className={classes.chanelStatusIcon} />
        case 'error':
          return <AccountAlertIcon className={classes.chanelStatusIcon} />
        default:
          break
      }
    }

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />
          
          { state.wizardFinished ? (
            ''
          ) : (
            <div style={{ width: 200, position: 'relative' }}>
              <AppStepper activeStep={this.state.activeStep} steps={steps} />
            
              <ArrowAside width={63} height={83} className={classes.arrowAside} />

              <a href="/wizard/crm/settings" className={classes.finishBtn}>
                <ButtonContained full={true} color="primary" text="Далее" />
              </a>

              <p className={classes.finishContent}>
                Вы сможете добавлять, изменять или удалять каналы для
                автоматической загрузки данных, а также вносить расходы вручную
                позже, из меню настроек.
              </p>
            </div>
          ) }

          <div className={classes.wizardContent}>
            <Wrapper shadow={4}>
              <section className={classes.content}>
                <Typography variant="h3" paragraph style={{ paddingTop: 24 }}>
                  Подключение рекламных площадок
                </Typography>
                <Typography
                  variant="subtitle1"
                  paragraph
                  style={{
                    padding: '6px 13px 6px',
                    backgroundColor: 'rgba(136, 102, 255, .15)',
                  }}
                >
                  Обратите пожалуйста внимание, что валюта платежного аккаунта площадки должна быть рубли.
                </Typography>
                <Typography
                  variant="subtitle1"
                  paragraph
                  style={{
                    padding: '6px 13px 6px',
                    backgroundColor: 'rgba(136, 102, 255, .15)',
                  }}
                >
                  Пожалуйста измените utm-метки кампаний, это нужно для того, чтобы наш сервис мог загрузить расходы из сервиса Google Ads.<br/><br/>
                  
                  Замените<br/>
                  utm_medium=cpc<br/>
                  utm_source=google_ads<br/><br/>
                
                  Если в кампаниях останутся метки<br/>
                  utm_source=google<br/>
                  Затраты по таким кампаниям будут переданы с меткой<br/>
                  utm_source=google_ads
                </Typography>

                {errorMessage ? (
                  <p
                    style={{
                      paddingLeft: 6,
                      fontSize: 14,
                      color: 'red',
                    }}
                  >
                    {errorMessage}
                  </p>
                ) : null}

              <div style={{
                width: '100%',
                textAlign: 'center'
              }}>
                <ButtonOutlined
                  type="button"
                  color="secondary"
                  text="Подключить"
                  href="/sources/google_abc/add"
                />
              </div>
                
              </section>
            </Wrapper>

            {/* <div
              style={{
                maxWidth: 500,
                margin: '20px 0 20px 30px',
              }}
            >
              <Typography variant="subtitle1" paragraph>
                По тем каналам, которые недоступны для автоматического импорта
                из рекламных площадок (например: рассылки, SEO-трафик), вы
                можете вносить затраты вручную.
              </Typography>

              <ButtonOutlined
                type="button"
                color="secondary"
                text="Добавить расходы вручную"
                href="/wizard/statistics"
                disabled={!hasStatistics ? true : false}
              />
            </div> */}
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(GoogleAdsSourceConfirm)
